<div class="btn-group" mdbDropdown>
  <a mdbDropdownToggle type="button" mdbBtn size="sm" color="light" class="dropdown-toggle waves-light z-depth-0 px-3 dropdown-light" mdbWavesEffect>
    <span class="{{color}}-text font-weight-bolder">{{ fontFamily }}</span>&nbsp;
  </a>
  <div class="dropdown-menu dropdown-dark dropdown-menu-right font-small app-theme-option-font-family">
    <a *ngFor="let font of fonts" class="dropdown-item z-depth-0" (click)="onFontFamily(font)">{{ font }}</a>
  </div>
</div>